module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/change-pwd/change-pwd.component.css
// module id = ./src/app/change-pwd/change-pwd.component.css
// module chunks = main